import { useState } from 'react';
import { ContractorCardPropsType } from '..';
import { getListByName } from '../util/getListByName';
import About from './About';
import ContractorList from './ContractorList';
import Error from './Error';
import TabsRow from './TabsRow';

type ContractorInfoPropsType = Pick<
  ContractorCardPropsType,
  | 'phone'
  | 'website'
  | 'brands'
  | 'products'
  | 'services'
  | 'additionalInformation'
  | 'sendContractorCardAnalytics'
>;

export type CategoryType = {
  name: string;
  array: string[];
};

type ShowContractorInfoType = Pick<
  ContractorCardPropsType,
  'phone' | 'website' | 'additionalInformation' | 'sendContractorCardAnalytics'
> & {
  categories: CategoryType[];
  currentTab: string;
};

export const showContractorInfo = ({
  currentTab,
  website,
  phone,
  additionalInformation,
  categories,
  sendContractorCardAnalytics,
}: ShowContractorInfoType) => {
  switch (currentTab) {
    case 'about':
      return (
        <About
          website={website}
          phone={phone}
          additionalInformation={additionalInformation}
          sendContractorCardAnalytics={sendContractorCardAnalytics}
        />
      );
    case 'brands':
    case 'products':
    case 'services':
      return (
        <ContractorList list={getListByName(currentTab, categories)} currentTab={currentTab} />
      );
    default:
      return <Error />;
  }
};

const ContractorInfo = ({
  phone,
  website,
  brands,
  products,
  services,
  additionalInformation,
  sendContractorCardAnalytics,
}: ContractorInfoPropsType) => {
  const [currentTab, setCurrentTab] = useState('about');

  const handleTabSelect = (tabName: string) => {
    setCurrentTab(tabName);
  };

  const categories = [
    { name: 'about', array: [] },
    {
      name: 'brands',
      array: brands,
    },
    {
      name: 'products',
      array: products,
    },
    {
      name: 'services',
      array: services,
    },
  ];

  return (
    <>
      <TabsRow currentTab={currentTab} categories={categories} handleTabSelect={handleTabSelect} />
      {showContractorInfo({
        currentTab,
        website,
        phone,
        additionalInformation,
        categories,
        sendContractorCardAnalytics,
      })}
    </>
  );
};

export default ContractorInfo;
